import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EmployeeUserModule from "@/store/modules/employeeuser.module";
import Loader from "../../../components/widgets/loader.vue";
import simplebar from "simplebar-vue";
import _ from "lodash";
import { EmployeeUserModel } from "@/store/models/employeeuser/employeeUser";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { EmployeeUserSearchDataModel } from "@/store/models/employeeuser/employeeUserSort";
import { SendResetPasswordMailRequestModel } from "@/store/models/users/sendResetPasswordMailRequest";
import employeeUserMachine from "./machines/EmployeeUserMachine";
import { interpret } from "xstate";
import { EmployeeUserEditModel } from "@/store/models/employeeuser/employeeUserEdit";
import multiselect from "vue-multiselect";
import EcSelect from "@/components/widgets/EcSelect.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import ECAlert from "@/components/ECAlert.vue";
import { ProjectOwnerDetailsModel } from "@/store/models/employeeuser/projectOwnerDetails";
import HostileTakeoverConfirmationComponent from "./components/HostileTakeoverConfirmationComponent.vue";
/**
 * User Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let EmployeeUser = /** @class */ (() => {
    let EmployeeUser = class EmployeeUser extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.selectedEmployee = null;
            this.selectedEmployeeId = null;
            this.selected = [];
            this.selectedEdit = [];
            this.employeeUser = new EmployeeUserModel();
            this.employeeUserEdit = new EmployeeUserEditModel();
            this.isloading = false;
            this.title = "Users";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Users",
                    active: true,
                },
            ];
            this.searchData = new EmployeeUserSearchDataModel();
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.userEmail = new SendResetPasswordMailRequestModel();
            this.columns = [
                {
                    field: "employeeId",
                    label: "Employee ID",
                    thClass: "employee-id-header",
                    tdClass: "employee-id",
                    sortable: true,
                },
                {
                    field: "employeeName",
                    label: "User",
                    thClass: "employee-id-header",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "User",
                    },
                },
                {
                    field: "email",
                    label: "Email ID",
                    sortable: false,
                },
                {
                    field: "role",
                    label: "Role",
                    sortable: true,
                },
                {
                    field: "status",
                    label: "Status",
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    tdClass: "employee-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "employeeId",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            //   MACHINE
            this.machine = employeeUserMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.projectOwnerDetails = new ProjectOwnerDetailsModel();
        }
        //METHODS
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                //gridOption: {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.machineService.send({ type: "GETTING_USERS", searchData: searchData });
        }
        //LifeCycle
        clearFilter() {
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        showAddUser() {
            this.selected = [];
            this.machineService.send({ type: "ADD_USER" });
        }
        showEditUser(id) {
            this.machineService.send({
                type: "EDIT_USER",
                employeeUserId: id,
            });
        }
        updateEmployeeUser() {
            this.editEmployeeUser.userRoles = this.selectedEdit;
            this.validate("editUserObserver").then((res) => {
                if (res) {
                    this.isloading = true;
                    this.machineService.send({
                        type: "EDITING_USER",
                        payload: this.editEmployeeUser,
                    });
                }
            });
        }
        cancelUserModal() {
            this.employeeUser.employeeId = "";
            this.employeeUser.roleId = [];
            this.selectedEmployee = null;
            this.selected = [];
            this.machineService.send({ type: "CANCEL_USER" });
        }
        cancelHostileTakeover() {
            this.selectedEmployeeId = null;
            this.projectOwnerDetails = new ProjectOwnerDetailsModel();
            this.userOwnedProjectDetails.forEach((p) => (p.selected = false));
            this.machineService.send({ type: "CANCEL_USER" });
        }
        takeOwnership() {
            this.projectOwnerDetails.userId = this.selectedEmployeeId;
            this.machineService.send({ type: "HOSTILE_TAKEOVER_CONFIRMATION", payload: this.projectOwnerDetails });
        }
        markAsUser() {
            this.employeeUser.roleId = this.selected.map((item) => item.id.toString());
            this.validate("addUserObserver").then((res) => {
                if (res) {
                    this.isloading = true;
                    this.machineService.send({
                        type: "ADDING_USER",
                        payload: this.employeeUser,
                    });
                }
            });
        }
        employeeSelected(evt) {
            this.selectedEmployee = EmployeeUserModule.validEmployees.find((x) => x.id == evt.target.value);
        }
        selectionChanged(selectedObjects) {
            if (this.state.matches("loadedEmployeesForAddUser")) {
                this.selected.push(selectedObjects);
            }
            if (this.state.matches("loadedEmployeesForEditUser")) {
                this.selectedEdit.push(selectedObjects);
            }
        }
        ResendInvitation(email) {
            this.userEmail.email = email;
            this.machineService.send({
                type: "RESEND_INVITATION",
                request: this.userEmail,
            });
        }
        deactivateUser(id) {
            this.selectedEmployeeId = id;
            this.machineService.send({
                type: "DEACTIVATE_USER",
                userId: id,
            });
        }
        activateUser(id) {
            this.selectedEmployeeId = id;
            this.machineService.send({
                type: "ACTIVATE_USER",
            });
        }
        hostileTakeoverUser() {
            this.machineService.send({
                type: "HOSTILE_TAKEN_OVER_USER",
                userId: this.selectedEmployeeId,
            });
        }
        showHostileTakeoverUser(id) {
            this.selectedEmployeeId = id;
            this.machineService.send({
                type: "HOSTILE_TAKE_OVER_USER",
            });
        }
        deactivatingUser() {
            this.machineService.send({
                type: "DEACTIVATING_USER",
                userId: this.selectedEmployeeId,
            });
        }
        activatingUser() {
            this.machineService.send({
                type: "ACTIVATING_USER",
                userId: this.selectedEmployeeId,
            });
        }
        cancel() {
            this.machineService.send({
                type: "CANCEL_USER",
            });
        }
        onRowClick() {
            return "";
        }
        onAssignToMeChange() {
            if (this.projectOwnerDetails.assignedAll) {
                this.projectOwnerDetails.assignedProjects = this.userOwnedProjectDetails.map((p) => p.id.toString());
                this.projectOwnerDetails.assignedMembers = [];
                // Uncheck all project selections
                this.userOwnedProjectDetails.forEach((p) => (p.selected = true));
            }
            else {
                this.projectOwnerDetails.assignedProjects = [];
                this.projectOwnerDetails.assignedMembers = [];
                this.userOwnedProjectDetails.forEach((p) => (p.selected = false));
            }
        }
        // Add a method to check if a member is selected for a project
        isMemberSelected(projectId, memberId) {
            return this.projectOwnerDetails.assignedMembers.some((m) => m.projectId === projectId && m.memberId === memberId);
        }
        // Add a method to handle member click
        toggleMemberSelection(projectId, memberId) {
            const idx = this.projectOwnerDetails.assignedMembers.findIndex((m) => m.projectId === projectId && m.memberId === memberId);
            if (idx >= 0) {
                // Deselect
                this.projectOwnerDetails.assignedMembers.splice(idx, 1);
            }
            else {
                // Remove any other member for this project (single selection)
                this.projectOwnerDetails.assignedMembers = this.projectOwnerDetails.assignedMembers.filter((m) => m.projectId !== projectId);
                // Add new selection
                this.projectOwnerDetails.assignedMembers.push({ projectId, memberId });
            }
        }
        // Add a method to check if 'Assign to me' should be disabled for a project
        isAssignToMeDisabled(projectId) {
            return this.projectOwnerDetails.assignedAll || this.projectOwnerDetails.assignedMembers.some((m) => m.projectId === projectId);
        }
        // Add a method to check if member avatars should be disabled for a project
        isMemberAvatarsDisabled(projectId) {
            return this.projectOwnerDetails.assignedAll && this.userOwnedProjectDetails.find((p) => p.id.toString() === projectId && p.selected);
        }
        assignProject(projectId) {
            const project = this.userOwnedProjectDetails.find((p) => p.id.toString() === projectId);
            if (project.selected) {
                // Add if not already there
                if (!this.projectOwnerDetails.assignedProjects.includes(projectId)) {
                    this.projectOwnerDetails.assignedProjects.push(projectId);
                }
            }
            else {
                this.projectOwnerDetails.assignedProjects = this.projectOwnerDetails.assignedProjects.filter((p) => p !== projectId);
            }
        }
        get employees() {
            return _.sortBy(EmployeeUserModule.validEmployees, (item) => item.value);
        }
        get Roles() {
            return EmployeeUserModule.roles;
        }
        get ddRules() {
            return "required|isNot:" + this.emptyGuid.toString();
        }
        get sortedRoles() {
            return _.sortBy(this.Roles, (o) => o.value);
        }
        get roleIdss() {
            return this.sortedRoles.map((role) => role.id);
        }
        get rows() {
            return EmployeeUserModule.users;
        }
        get totalUser() {
            return EmployeeUserModule.totalUsers;
        }
        get editEmployeeUser() {
            return EmployeeUserModule.editEmployeeUser;
        }
        get userName() {
            if (this.selectedEmployeeId != null) {
                return EmployeeUserModule.users.find((x) => x.id == this.selectedEmployeeId)?.employeeName;
            }
            return "";
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get userOwnedProjectDetails() {
            return EmployeeUserModule.userOwnedProjectDetails;
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get isProjectMemberComboSelected() {
            return this.projectOwnerDetails.assignedMembers.length + this.projectOwnerDetails.assignedProjects.length;
        }
        get isProjectOwnershipValid() {
            return !this.projectOwnerDetails.assignedAll && this.isProjectMemberComboSelected != this.userOwnedProjectDetails.length;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("gettingUsers") || this.state.matches("loadedUsers")) {
                    this.$bvModal.hide("add_employee_user");
                    this.$bvModal.hide("edit-employee-user");
                    this.$bvModal.hide("hostile-takeover-user");
                }
                if (this.state.matches("checkingHostileTakeover")) {
                    // Show loading state while checking hostile takeover
                    this.isloading = true;
                }
                if (this.state.matches("hostileTakeoverUser") && previousState.matches("checkingHostileTakeover")) {
                    // Hide loading and show hostile takeover confirmation
                    this.isloading = false;
                }
                if (this.state.matches("deactivateUser") && previousState.matches("checkingHostileTakeover")) {
                    // Hide loading and show deactivation confirmation
                    this.isloading = false;
                }
                if (this.state.matches("gettingEmployees")) {
                    this.$bvModal.show("add_employee_user");
                }
                if (this.state.matches("editUserRole")) {
                    this.$bvModal.show("edit-employee-user");
                }
                if (this.state.matches("hostileTakenOverUserProjectDetails")) {
                    this.$bvModal.show("hostile-takeover-user");
                }
                if (this.state.matches("loadedEmployeesForEditUser")) {
                    this.selectedEdit = this.editEmployeeUser.userRoles;
                }
                if (this.state.matches("idle")) {
                    this.$bvModal.hide("edit-employee-user");
                }
                if ((this.state.matches("gettingUsers") && previousState.matches("editingUserRole")) || (this.state.matches("gettingUsers") && previousState.matches("markAsUser"))) {
                    this.isloading = false;
                }
                if (this.state.matches("loadedUsers")) {
                    this.totalCount = this.totalUser;
                    this.isGridLoading = false;
                    this.deactivateReason = "";
                }
                if (this.state.matches("gettingUsers") && previousState.matches("markAsUser")) {
                    this.isGridLoading = true;
                    this.$bvModal.hide("add_employee_user");
                    this.$bvModal.hide("edit-employee-user");
                    this.totalCount = this.totalUser;
                    this.employeeUser.employeeId = this.selectedEmployeeId;
                    this.employeeUser.roleId = [];
                    this.selectedEmployee = null;
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    EmployeeUser = __decorate([
        Component({
            name: "EmployeeUsers",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                EcGrid,
                multiselect,
                EcSelect,
                SectionLoader,
                ECAlert,
                HostileTakeoverConfirmationComponent,
            },
        })
    ], EmployeeUser);
    return EmployeeUser;
})();
export default EmployeeUser;
